module.exports = __webpack_public_path__ + "static/media/icons.6794c3f8.font";